import React, { useState, useImperativeHandle, forwardRef } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const ToastManager = forwardRef((props, ref) => {
    const [toasts, setToasts] = useState([]);

    const createToast = (title, text, variant = "light") => {
        const newToast = {
            id: Date.now(),
            title,
            text,
            variant,
            show: true
        };

        setToasts((prevToasts) => [...prevToasts, newToast]);
    }

    const removeToast = (id) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id))
    }

    useImperativeHandle(ref, () => ({
        createToast,
    }))

    return <ToastContainer position="bottom-end" className="mb-1 me-1">
        {
            toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    show={toast.show}
                    onClose={() => removeToast(toast.id)}
                    delay={5000}
                    autohide
                    bg={toast.variant.toLowerCase()}
                >
                    <Toast.Header>
                        <strong className="me-auto">
                            {toast.title}
                        </strong>
                    </Toast.Header>
                    <Toast.Body>
                        {toast.text}
                    </Toast.Body>
                </Toast>
            ))
        }
    </ToastContainer>

})

export default ToastManager;